module.exports = __webpack_public_path__ + "static/img/One_Pair.e0d69cd.svg";